import { render, screen } from '@testing-library/react'
import AxesPage from './AxesPage'

describe('AxesPage', () => {
  test('renders the existing intervention axes as a standalone page', () => {
    render(<AxesPage />)

    expect(screen.getByRole('heading', { name: /ejes de intervención/i })).toBeTruthy()
    expect(screen.getAllByRole('heading', { name: /ejes/i })).toHaveLength(2)
    expect(screen.getAllByRole('heading', { name: 'EDUCACIÓN' })).toHaveLength(2)
    expect(screen.getAllByRole('heading', { name: 'INVESTIGACIÓN' })).toHaveLength(2)
    expect(screen.getAllByRole('heading', { name: 'DIVULGACIÓN' })).toHaveLength(2)
    expect(screen.getAllByRole('heading', { name: 'ACTIVISMO' })).toHaveLength(2)
    expect(screen.getAllByRole('heading', { name: 'RED' })).toHaveLength(2)
  })
})
